import { Component, Input, OnInit, AfterViewInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Dropdown } from '@eds/vanilla/dropdown/Dropdown';
import { Router, ActivatedRoute } from '@angular/router';
import {userUsageService} from '../service/userUsage.service';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import {Donut} from '@eds/vanilla/charts/donut/Donut';
import {LineChart} from '@eds/vanilla/charts/line-chart/LineChart';
import { learningContentDataService } from '../service/contentUsage.data.service';
declare var jQuery: any;

@Component({
  selector: 'app-data-content-component',
  templateUrl: './data-content-component.component.html',
  styleUrls: ['./data-content-component.component.css'],
  providers: [userUsageService]
})
export class DataContentComponentComponent implements OnInit, OnDestroy, AfterViewInit {

  /* @ViewChild("contentoverviewdrop", {static: false})
  private contentoverviewMenu: ElementRef; */
  @Input() dataFiltered: string;
  @ViewChild('contenttrenddrop', {static: false})
  private contenttrendMenu: ElementRef;

  @ViewChild('contentnewdrop', {static: false})
  private contentnewMenu: ElementRef;


  // in use
  math: any = Math;
  lineChartLoaded=false;
  isDonutChartLoaded1=false;
  isDonutChartLoaded2=false;
  subscription = [];
edsContentData1:any;
edsContentData2:any;
lineChartData:any;
  data_04 = [
    {id: 'Video', count: 300},
    {id: 'Documents', count: 300},
    {id: 'Audio', count: 300},
    {id: 'eLearning Courses', count: 300}
  ];
seriesData:any;
commonArr :any;

  settings_04 = {
    selector: 'learningContentChartTab',
    width: 203,
    height: 203,
    hole: 90,
    colors : ['#613675', '#11c273', '#1a609b', '#819eb7'],
    total: 'sum',
    totalText: 'Learning Items'
  };
  sumofContentItems: any = [];

  data_05 = [];

  settings_05 = {
    selector: 'contentUseDailyTrendChart',
    width: 800,
    height: 280,
    colors : ['#613675', '#11c273', '#1a609b', '#819eb7']
  };

  data_06 = [
   
    {id: 'documents', count: 300},
    {id: 'link', count: 0},
    {id: 'video', count: 0}
  ];

  settings_06 = {
    selector: 'newLearningContentChart',
    width: 203,
    height: 203,
    hole: 90,
    colors : ['#613675', '#11c273', '#1a609b', '#819eb7'],
    total: 'sum',
    totalText: 'Learning Items'
  };
  sumofNewContentItems: any = [];
  fontBig = '64px';
  fontSmall = '44px';
  textDir:any;
  constructor(private contentUsageService: learningContentDataService) {
    this.textDir = sessionStorage.getItem('textDir');
   }

  ngOnInit() {
    this.loadAllSectionsData();
  }

  ngOnDestroy() {
    this.subscription.forEach(sub => {
      sub.unsubscribe();
    });
  }
  ngDoCheck() {
    
      if (document.getElementById('contentLinechart')){
      if (!this.lineChartLoaded && document.getElementById('contentLinechart').clientHeight > 0){
        document.getElementById('contentLinechart').innerHTML = '';
       //console.log("content tab")
        this.linechartInit();
        setTimeout(function(){​​​​ 
          jQuery('#contentLinechart').find('rect').attr('pointer-events','none');
        }​​​​, 1000);
        this.lineChartLoaded = true;
      }
    } 
  
  }
  ngAfterViewInit() {
    const contenttrendDrop = new Dropdown(this.contenttrendMenu.nativeElement);
    contenttrendDrop.init();

    const contentnewDrop = new Dropdown(this.contentnewMenu.nativeElement);
    contentnewDrop.init();
  }
  linechartInit(){

    document.getElementById('contentLinechart').innerHTML="";
    const linechart = new LineChart({
      element: document.getElementById('contentLinechart'),
      data: this.lineChartData,
      height: 250,
      margin: {
        left: 35,
      },
      y: {
        unit: 'Items viewed',
      }


    });
    
   linechart.init();
    
  }
  donutChartInit1(){
    document.getElementById('contentDonut').innerHTML="";
    const chart1 = new Donut({
      element: document.getElementById('contentDonut'),
      data: this.edsContentData1,     
      showValue: true,
      showAbsoluteValue:true,
      unit: 'Learning items'
    });
    chart1.init();
   
  }
  donutChartInit2(){
    document.getElementById('contentDonut1').innerHTML="";
    const chart2 = new Donut({
      element: document.getElementById('contentDonut1'),
      data: this.edsContentData2,     
      showValue: true,
      showAbsoluteValue:true,
      unit: 'Learning items'
    });
    chart2.init();
   
  }
  loadAllSectionsData() {
    // content
    const sub4 = this.contentUsageService.contentUsage$Data.subscribe(data => {
      // load all services
      this.contentUsageService.getContentOverviewData();
      this.contentUsageService.getContentDailyTrendData();
      this.contentUsageService.getNewContentUploadData();

      // all data subscription
      this.getContentOverview();
      this.getContentOverviewTab();
      this.getContentDailyUsageTrend();
      this.getNewContentOverview();
      this.getNewContentOverviewTab();
    });
    this.subscription.push(sub4);
  }

  getContentOverview() {
    const sub = this.contentUsageService.contentOverview$Data.subscribe(data => {
      this.data_04 = [...data];
      console.log("this.data_04 >>>> "+JSON.stringify(this.data_04));
        const edsDataObj3 = [];
        this.data_04.forEach((a,index) => {
          const dataObj1 = {name: a.id, values: [a.count], colorID: (index+1).toString()};
          edsDataObj3.push(dataObj1);
        });
        // edsDataObj.push({name: 'test', value: ['300'], colorID: '3'});
       // this.edsContentData1 = {series: edsDataObj3};
        const nodataObj4 = [{name:"Videos",values:[200],colorID:"1"},{name:"Documents",values:[120],colorID:"2"},{name:"Audio",values:[40],colorID:"3"}]
        
        if(this.data_04.length>0){
          this.edsContentData1 = {"series": edsDataObj3};

        }else{

          this.edsContentData1 = {"series": nodataObj4};
        }
        this.donutChartInit1();
    });
  
 
    this.subscription.push(sub);
  }

  getContentOverviewTab() {
    const sub = this.contentUsageService.contentOverviewTab$Data.subscribe(data => {
      this.sumofContentItems = [...data];
      if(this.sumofContentItems.length==0){

        this.sumofContentItems = [{"id":"Videos","content_count":0,"user_count":0,"launch_count":0,"complete_count":0},{"id":"Documents","content_count":0,"user_count":0,"launch_count":0,"complete_count":0},{"id":"Audio","content_count":0,"user_count":0,"launch_count":0,"complete_count":0}]
      }
    });
    this.subscription.push(sub);
  }

  getContentDailyUsageTrend() {
    const sub = this.contentUsageService.contentDailyTrend$Data.subscribe(data => {
    this.data_05 = [...data];
    const commonArr = [];
    let valuesArr = [];
    let idArr = [];   
    this.data_05.forEach((item,index) => {   
      let i = 0;
     for (const items of item.values) {      
        i++;
        valuesArr.push({name:item.id,values:items.count, date:items.date});
        commonArr.push(items.date);      
      }   
     
      this.seriesData = valuesArr;
      this.commonArr = commonArr;
    });

    const seriesData = this.groupObj(this.seriesData, 'name');    
   // this.lineChartData = {series: seriesData, common:this.commonArr};
   ///data_06 >>> [{"id":"document","count":2},{"id":"link"},{"id":"video"}]

    let common = ["2018-11-14","2018-11-13","2018-11-12","2018-11-11","2018-11-10"]
    let series = [{name:"Video",values:["0","10","20","30","40"]},{name:"Documents", values:["0","10","20","30","40"]},{name:"Audio", values:["0","10","20","30","40"]},{name:"eLearning courses", values:["0","10","20","30","40"]}]
    
    
    if(this.data_05.length>0){
      this.lineChartData = {series: seriesData, common:this.commonArr};
    /*   setTimeout(function(){​​​​ 
        jQuery('#contentLinechart').find('rect').attr('pointer-events','all');
      }​​​​, 1000); */
    }else{
      this.lineChartData = {series: series, common:common};
    /*   setTimeout(function(){​​​​ 
        jQuery('#contentLinechart').find('rect').attr('pointer-events','none');
      }​​​​, 1000); */
    }

    this.linechartInit();
   
    });
    this.subscription.push(sub);
  }

 groupObj(array, key){
  var result=_.chain(array).groupBy(key).map(function(v, i) {
    return {
      name: i,  
      date: _.map(v, 'date'), 
      values: _.map(v, 'values')
    }
  }).value();
  return result;
 }

  getNewContentOverview() {
    const sub = this.contentUsageService.newContentOverview$Data.subscribe(data => {
     this.data_06 = [...data];
     //this.data_06 = [{'id':'document','count':2},{'id':'link'},{'id':'video'}]
      const edsDataObj2 = [];
      console.log("data_06 >>> "+JSON.stringify(this.data_06))
      this.data_06.forEach((a,index) => {
        const dataObj1 = {name: a.id, values: [Number(a.count)], colorID: (index+1).toString()};
        edsDataObj2.push(dataObj1);
      });
      // edsDataObj.push({name: 'test', value: ['300'], colorID: '3'});
      //this.edsContentData2 = {series: edsDataObj2};
      const nodataObj2 = [{name:"Videos",values:[200],colorID:"1"},{name:"Documents",values:[120],colorID:"2"},{name:"Audio",values:[40],colorID:"3"}]
        
      if(this.data_06.length>0){
        this.edsContentData2 = {"series": edsDataObj2};

      }else{

        this.edsContentData2 = {"series": nodataObj2};
      }
      this.donutChartInit2(); 
    });
   
    this.subscription.push(sub);
  }

  getNewContentOverviewTab() {
    const sub = this.contentUsageService.newContentOverviewTab$Data.subscribe(data => {
      this.sumofNewContentItems = [...data];
     //console.log("this.sumofNewContentItems jani >>> "+JSON.stringify(this.sumofNewContentItems))
      if(this.sumofNewContentItems.length==0){

        this.sumofNewContentItems = [{"id":"Videos","content_count":0,"curriculum_count":0},{"id":"Documents","content_count":0,"curriculum_count":0},{"id":"Audio","content_count":0,"curriculum_count":0}]
      }
    });
    this.subscription.push(sub);
  }

  generateCSV(section: any) {
    if (section === 'content-overview') {
      const csv = this._objectArrayToCsv(this.sumofContentItems);
      this._downloadFile(section, csv);
    }
    if (section === 'content-trend') {
      let csv = new Array();
      this.data_05.forEach(item => {
        csv.push(item.id);
        csv.push('');
        csv = csv.concat(this._objectArrayToCsv(item.values));
        csv.push('');
      });
      this._downloadFile(section, csv);
    }

    if (section === 'content-new') {
      const csv = this._objectArrayToCsv(this.sumofNewContentItems);
      this._downloadFile(section, csv);
    }
  }

  _downloadFile(section, csv) {
    const csvArray = csv.join('\r\n');
    const blob = new Blob([csvArray], {type: 'text/csv' })
    saveAs(blob, 'overview-' + section + '.csv');
  }

  _objectArrayToCsv(data: any) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    return csv;
  }

}
